module.exports = __webpack_public_path__ + "static/sverigesveteranforbund-1885fe1bd5cbab297f20461db91bd002.png";